import { Component, ChangeDetectionStrategy } from '@angular/core';
import { JobFormComponent } from '../../../feature/job-form/job-form.component';

@Component({
  selector: 'app-job-form-fuse',
  templateUrl: './job-form-fuse.component.html',
  styleUrls: ['./job-form-fuse.component.scss']
  ,changeDetection: ChangeDetectionStrategy.OnPush
})
export class JobFormFuseComponent extends JobFormComponent {

  /**
   * Met en gras la partie du texte correspondant à la recherche,
   * et capitalise uniquement la première lettre du résultat.
   * Ex : highlightMatch('automobile', 'auto') → '<strong>Auto</strong>mobile'
   */
  highlightMatch(text: string, search: string | any): string {
    if (!text) return '';
    // Capitalize first letter only
    let result = text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    const searchStr = (typeof search === 'string' ? search : search?.name || '').trim();
    if (!searchStr) return result;
    const escaped = searchStr.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escaped})`, 'gi');
    return result.replace(regex, '<strong>$1</strong>');
  }

  onJobSuggestOptionSelection(event: any): void {
    if (event && event.isUserInput) {
      this.showJobSuggestionField = true;
      const currentQuery = (this.searchJobControl.value || '').toString().trim();
      if (currentQuery) {
        this.suggestedJobControl.setValue(currentQuery, { emitEvent: false });
      }
      this.selectedJob = null;
      this.getAutreJob(true, () => {
        if (this.autreJob && !this.jobs.some(j => j.id === this.autreJob.id)) {
          this.jobs = [this.autreJob, ...this.jobs];
        }
        // Rétablir la valeur saisie si selectJob(autre) l'a vidée
        if (currentQuery) {
          this.suggestedJobControl.setValue(currentQuery, { emitEvent: false });
        }
        this['patchUserAfterJobSuggestion'](currentQuery);
        this.cdr.detectChanges();
      });
    }
  }

  onBusinessSuggestOptionSelection(event: any): void {
    if (event && event.isUserInput) {
      this.showBusinessSuggestionField = true;
      const currentQuery = (this.searchBusinessControl.value || '').toString().trim();
      if (currentQuery) {
        this.suggestedBusinessControl.setValue(currentQuery, { emitEvent: false });
      }
      this.selectedBusiness = null;
      this.getAutreBusiness(true, () => {
        if (this.autreBusiness && !this.businesses.some(b => b.id === this.autreBusiness.id)) {
          this.businesses = [this.autreBusiness, ...this.businesses];
        }
        if (currentQuery) {
          this.suggestedBusinessControl.setValue(currentQuery, { emitEvent: false });
        }
        this['patchUserAfterBusinessSuggestion'](currentQuery);
        this.cdr.detectChanges();
      });
    }
  }
}
